import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import { verification } from '../../Constant'

function SubmitFeedBack() {
  return (
    <>
    <Header />
    <section className="jobs">
    <div className="container">

    </div>
</section>

<div className="container">
    <div id="verificationlogin" className="row justify-content-center align-items-center py-5">
        <div id="login-column" className="col-md-8 ">
            <div id="verification" className="col-md-12 py-5">
                <form id="login-form" className="form" action="" method="post">
                    <h3 className="text-center text-signin bottom-border ">
                        <img src={verification} /></h3>
                    <h3 className="text-center blue">Thank you For Sharing your experience </h3>
                    <p></p>


                    <p className="text-center">Your feedback is important for us and the community using "My Home helper"
                    </p>
                    <div id="register-link" className="text-center py-2">
                        <Link to="/" name="submit" className="btn btn-blue text-white" value="">Go back to Homepage</Link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
    <Footer />
    </>
  )
}

export default SubmitFeedBack